import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

const NotificationMessagePopup = (props) => {
  const {
    message,
    openPopUp,
    setNotificationMessage,
    setOpenNotification,
    setOpenConfirmationDialog,
  } = props;

  const handleOk = () => {
    setOpenNotification(false);
    setNotificationMessage('');
    setOpenConfirmationDialog(false);
  };

  return (
    <>
      <Dialog fullWidth={true} maxWidth={'xs'} open={openPopUp}>
        <DialogTitle>Notification</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {message}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button variant="text" onClick={handleOk}>
            Ok
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default NotificationMessagePopup;
